import { render, staticRenderFns } from "./BookCardPopUp.vue?vue&type=template&id=2b156b4c&scoped=true&"
import script from "./BookCardPopUp.vue?vue&type=script&lang=js&"
export * from "./BookCardPopUp.vue?vue&type=script&lang=js&"
import style0 from "./BookCardPopUp.vue?vue&type=style&index=0&id=2b156b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b156b4c",
  null
  
)

export default component.exports